import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const RESIDENTS_ROUTES: Routes = [
  {
    path: 'residents/list',
    loadComponent: () => import('../features/residents/list/list.component').then(m => m.ResidentsListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'residents/add',
    loadComponent: () => import('../features/residents/add/add.component').then(m => m.ResidentAddComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'residents/edit/:id',
    loadComponent: () => import('../features/residents/edit/edit.component').then(m => m.ResidentEditComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'residents/activite-tracee/select',
    loadComponent: () =>
      import('../features/residents/activite-tracee-select/activite-tracee-select.component').then(
        m => m.ActiviteTraceeSelectComponent
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
  {
    path: 'residents/:id/activite-tracee',
    loadComponent: () =>
      import('../features/residents/activite-tracee/activite-tracee.component').then(m => m.ActiviteTraceeComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.ADMIN, ROLES.SUPERADMIN, ROLES.TECH],
    },
  },
];
